var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "myCustomers" } } },
              [_c("div", { staticClass: "div3" }, [_vm._v("我的客户")])]
            ),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("客户订单")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "inquiry" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              inline: true,
              model: _vm.queryForm,
              "label-width": "",
              size: "mini",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "信息" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入客户手机号码/姓名" },
                  model: {
                    value: _vm.queryForm.info,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryForm, "info", $$v)
                    },
                    expression: "queryForm.info",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "selectDate" }, [
              _c("span", [_vm._v("时间")]),
              _c(
                "div",
                { staticClass: "picker" },
                [
                  _c(
                    "el-date-picker",
                    {
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "yyyy- MM- dd",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    },
                    [_vm._v("> ")]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: "订单编号" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入订单编号" },
                  model: {
                    value: _vm.queryForm.identifier,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryForm, "identifier", $$v)
                    },
                    expression: "queryForm.identifier",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "订单状态" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "选择订单状态" },
                    model: {
                      value: _vm.queryForm.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "state", $$v)
                      },
                      expression: "queryForm.state",
                    },
                  },
                  _vm._l(_vm.status, function (itemsS) {
                    return _c("el-option", {
                      key: itemsS.dictId,
                      attrs: { label: itemsS.dictName, value: itemsS.dictId },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.listAxios(1)
                      },
                    },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  { attrs: { plain: "" }, on: { click: _vm.reset } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c(
          "el-table",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData.list,
              "expand-row-keys": _vm.expends,
              "row-key": _vm.getRowKeys,
            },
          },
          [
            _c("el-table-column", {
              attrs: { type: "index", label: "序号", width: "50" },
            }),
            _c("el-table-column", {
              attrs: { type: "expand", "show-overflow-tooltip": true },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.toDetail(props.row)
                            },
                          },
                        },
                        [
                          _c(
                            "el-form",
                            { staticClass: "demo-table-expand" },
                            [
                              _c(
                                "el-form-item",
                                _vm._l(
                                  props.row.orderCommodityList,
                                  function (items) {
                                    return _c("p", { key: items.id }, [
                                      _c("span", [_vm._v(_vm._s(items.name))]),
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(items.price) +
                                            " × " +
                                            _vm._s(items.number) +
                                            " = " +
                                            _vm._s(items.total) +
                                            " 元"
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                              !_vm.is_null(props.row.orderComplimentaryList)
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("附属品：")]
                                      ),
                                      _vm._l(
                                        props.row.orderComplimentaryList,
                                        function (items) {
                                          return _c(
                                            "p",
                                            {
                                              key: items.id,
                                              staticClass: "complimentary",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    items.complimentaryName
                                                  )
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(items.price) +
                                                    " × " +
                                                    _vm._s(items.number) +
                                                    " = " +
                                                    _vm._s(items.total) +
                                                    " 元"
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "订单编号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "单击复制",
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.copyButton(props.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(props.row.orderUser.orderIdStr) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "下单时间", prop: "orderUser.createdTime" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "客户",
                prop: "orderUser.addressName",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "订单状态" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.orderTypeSelf[props.row.orderUser.orderType]
                                ? props.row.orderUser.orderType
                                : _vm.orderTypeSelf[
                                    props.row.orderUser.orderType
                                  ]
                            ) +
                            " "
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "销售：" + _vm._s(props.row.orderUser.employeeName)
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "总计" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("p", [
                        _vm._v("总价：￥" + _vm._s(props.row.orderUser.total)),
                      ]),
                      _c("p", [
                        _vm._v(
                          "已收：￥" + _vm._s(props.row.orderUser.receivedMoney)
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "待收：￥" +
                            _vm._s(props.row.orderUser.awaitIncomeMoney)
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "备注", "show-overflow-tooltip": true },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm.is_null(props.row.orderUser.comment)
                        ? _c("span", [_vm._v("--")])
                        : _vm._e(),
                      !_vm.is_null(props.row.orderUser.comment)
                        ? _c("span", [
                            _vm._v(_vm._s(props.row.orderUser.comment)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("div", { staticClass: "btn" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.againdOrder(props.row)
                              },
                            },
                          },
                          [_vm._v("复购订单")]
                        ),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.toDetail(props.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("div", { staticClass: "page" }, [
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("span", { staticClass: "demonstration" }, [
                _vm._v("共" + _vm._s(_vm.tableData.totalPage) + "页"),
              ]),
              _c("span", { staticClass: "demonstration" }, [
                _vm._v("共" + _vm._s(_vm.tableData.totalNum) + "条"),
              ]),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.currentPage1,
                  "page-size": 1,
                  layout: "prev, pager, next",
                  "prev-text": "上一页",
                  "next-text": "下一页",
                  total: _vm.tableData.totalPage,
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    _vm.currentPage1 = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPage1 = $event
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }